import { render, staticRenderFns } from "./book.vue?vue&type=template&id=68cfcb85&functional=true"
import script from "./book.vue?vue&type=script&lang=js"
export * from "./book.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports